import { DefaultOauthLink, ForgotPasswordLink, LoginLink } from "../constants/general";
import { DomUtils } from "../utils/domUtils";
import { LocationUtils } from "../utils/locationUtils";
import { ValidatedInput } from "../components/validatedInput";
import { BaseController } from "./base";

export const ResetPasswordConstants = {
	resetPasswordForm: "resetPasswordForm",
	firstName: "firstName",
	lastName: "lastName",
	emailAddress: "emailAddress",
	mobilePhone: "mobilePhone",
	canSendText: "canSendText",
	resetPasswordButton: "resetPasswordButton",
	loginLink: "loginLink"
};

export class ResetPasswordController extends BaseController {
	constructor() {
		super();

		this._message = null;
		this._signIn = null;
		this._loginLink = null;
		this._returnUrl = null;

		this._firstName = null;
		this._lastName = null;
		this._emailAddress = null;
		this._mobilePhone = null;

		this._canSendText = false;
	}

	Init() {
		this._GetContextData();

		this._ShowMessage(this._message);

		this._SetupForm();
		this._SetupPhoneMask(ResetPasswordConstants.mobilePhone, this._domainPhoneMask);

		this._BindEvents();

		this._FocusElement(ResetPasswordConstants.firstName);
	}

	_GetContextData() {
		this._message = window.message || LocationUtils.GetQueryParam("message");
		this._signIn = LocationUtils.GetQueryParam("signin");

		if (!!this._signIn) {
			this._loginLink = `${LoginLink}${this._signIn}`;
		}
		else {
			this._loginLink = DefaultOauthLink;
		}

		if (!!window.viewModel) {
			this._returnUrl = window.viewModel.ReturnUrl;
			this._firstName = window.viewModel.FirstName;
			this._lastName = window.viewModel.LastName;
			this._emailAddress = window.viewModel.EmailAddress;
			this._mobilePhone = window.viewModel.MobilePhone;
		}

		if (!!window.domainProperties) {
			this._canSendText = window.domainProperties.HasSMSConfigured === true;
			this._domainPhoneMask = window.domainProperties.PhoneMask;
		}
	}

	_SetupForm() {
		const firstNameElement = DomUtils.GetElement(ResetPasswordConstants.firstName);
		firstNameElement.value = this._firstName;
		ValidatedInput.Init(firstNameElement);

		const lastNameElement = DomUtils.GetElement(ResetPasswordConstants.lastName);
		lastNameElement.value = this._lastName;
		ValidatedInput.Init(lastNameElement);

		const emailAddressElement = DomUtils.GetElement(ResetPasswordConstants.emailAddress);
		emailAddressElement.value = this._emailAddress;
		ValidatedInput.Init(emailAddressElement);

		const mobilePhoneElement = DomUtils.GetElement(ResetPasswordConstants.mobilePhone);
		mobilePhoneElement.value = this._mobilePhone;
		ValidatedInput.Init(mobilePhoneElement);

		const loginLinkElement = DomUtils.GetElement(ResetPasswordConstants.loginLink);
		loginLinkElement.href = this._loginLink;

		const resetPasswordFormElement = DomUtils.GetElement(ResetPasswordConstants.resetPasswordForm);
		resetPasswordFormElement.action = ForgotPasswordLink + this._signIn;
	}

	_BindEvents() {
		this._BindResetPasswordClick();
	}

	_BindResetPasswordClick() {
		const resetPasswordButtonElement = DomUtils.GetElement(ResetPasswordConstants.resetPasswordButton);
		resetPasswordButtonElement.addEventListener("click", this._OnResetPassword.bind(this));
	}

	_OnResetPassword() {
		if (this._Validate() === true) {
			this._SubmitForm();
		}
	}

	/* istanbul ignore next */
	_SubmitForm() {
		super._SubmitForm(ResetPasswordConstants.resetPasswordForm);
	}

	_Validate() {
		const firstNameElement = DomUtils.GetElement(ResetPasswordConstants.firstName);
		const lastNameElement = DomUtils.GetElement(ResetPasswordConstants.lastName);
		const emailAddressElement = DomUtils.GetElement(ResetPasswordConstants.emailAddress);
		const mobilePhoneElement = DomUtils.GetElement(ResetPasswordConstants.mobilePhone);

		let result = true;

		if (firstNameElement.validate() != null) {
			result = false;
		}

		if (lastNameElement.validate() != null) {
			result = false;
		}

		const emailValidationResult = emailAddressElement.validate();
		const mobilePhoneValidationResult = mobilePhoneElement.validate();

		if (emailValidationResult != null && mobilePhoneValidationResult != null) {
			result = false;
		}
		else if (emailValidationResult != null && mobilePhoneValidationResult == null) {
			emailAddressElement.resetValidationState();
		}
		else if (emailValidationResult == null && mobilePhoneValidationResult != null) {
			mobilePhoneElement.resetValidationState();
		}

		return result;
	}
}
